"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Cpu } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StopOverpayingForRepairs() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: graphicRef,
    isVisible: isGraphicVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const repairItems = [{
    id: 1,
    name: "Servo Amplifiers"
  }, {
    id: 2,
    name: "Backlight Replacement"
  }, {
    id: 3,
    name: "Spindle Drive Modules"
  }, {
    id: 4,
    name: "Control Power Supply Modules"
  }, {
    id: 5,
    name: "Power Supply Modules"
  }, {
    id: 6,
    name: "Fanuc, Mitsubishi, Haas, and more"
  }];
  return <section id="stop-overpaying-for-repairs" className="dark bg-background text-foreground relative w-full">
      {}
      <div className="relative bg-destructive text-destructive-foreground pt-24 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
        
        {}
        <div className="absolute top-0 left-0 w-full overflow-hidden leading-none z-20">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[20px] md:h-[30px]" aria-hidden="true">
            <path d="M0,0 L0,120 L25,60 L50,120 L75,60 L100,120 L125,60 L150,120 L175,60 L200,120 L225,60 L250,120 L275,60 L300,120 L325,60 L350,120 L375,60 L400,120 L425,60 L450,120 L475,60 L500,120 L525,60 L550,120 L575,60 L600,120 L625,60 L650,120 L675,60 L700,120 L725,60 L750,120 L775,60 L800,120 L825,60 L850,120 L875,60 L900,120 L925,60 L950,120 L975,60 L1000,120 L1025,60 L1050,120 L1075,60 L1100,120 L1125,60 L1150,120 L1175,60 L1200,120 L1200,0 Z" className="fill-background" />
          </svg>
        </div>

        {}
        <div className="absolute inset-0 bg-gradient-to-br from-black/10 to-transparent pointer-events-none" />

        <div className="max-w-7xl mx-auto relative z-10 flex flex-col lg:flex-row items-center justify-between gap-16 lg:gap-8">
          
          {}
          <div ref={textRef} className={`flex-1 text-center lg:text-left space-y-8 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h2 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-white tracking-tighter uppercase leading-[0.85] drop-shadow-md">
              Stop Overpaying.
            </h2>
            <p className="text-xl md:text-2xl text-white/90 max-w-2xl mx-auto lg:mx-0 font-medium leading-relaxed">Buying replacement components from the manufacturer is draining your profits. With a CNCWise subscription, get expert electronic component repairs at a 25% discount of our standard repair pricing. All done in-house, by the same team of technicians that brought you CNCWise.</p>
            
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8 max-w-2xl mx-auto lg:mx-0">
              {repairItems.map((item, i) => <li key={item.id} data-index={i} className="flex items-center gap-3 text-white font-bold uppercase tracking-widest text-xs sm:text-sm group">
                  <div className="w-2 h-2 bg-secondary group-hover:scale-125 transition-transform shrink-0" />
                  {item.name}
                </li>)}
            </ul>

            <div className="pt-4">
              <Button size="lg" className="bg-white text-destructive hover:bg-white/90 font-black text-xl px-10 py-8 hover:translate-y-1 hover:translate-x-1 hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,0.4)] transition-all uppercase tracking-wide" asChild>
                <Link to="https://app.cncwise.com/signup">Save on Repairs Now</Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={graphicRef} className={`flex-1 relative w-full max-w-2xl mx-auto flex justify-center items-center min-h-[400px] transition-all duration-1000 delay-300 ease-out ${isGraphicVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"}`}>
            {}
            <div className="absolute inset-0 grid grid-cols-3 grid-rows-3 gap-4 opacity-30 p-8 pointer-events-none">
              <div className="border-t-4 border-l-4 border-white rounded-tl-[3rem]" />
              <div className="border-t-4 border-white relative">
                <div className="absolute top-[-6px] left-1/2 w-3 h-3 bg-white rounded-lg -translate-x-1/2" />
              </div>
              <div className="border-t-4 border-r-4 border-white rounded-tr-[3rem]" />
              <div className="border-l-4 border-white relative">
                <div className="absolute left-[-6px] top-1/2 w-3 h-3 bg-white rounded-lg -translate-y-1/2" />
              </div>
              <div className="flex items-center justify-center">
                <Cpu className="w-24 h-24 text-white drop-shadow-lg" strokeWidth={1.5} />
              </div>
              <div className="border-r-4 border-white" />
              <div className="border-b-4 border-l-4 border-white rounded-bl-[3rem]" />
              <div className="border-b-4 border-white" />
              <div className="border-b-4 border-r-4 border-white rounded-br-[3rem]" />
            </div>

            {}
            <div className="relative z-10 flex items-center justify-center w-56 h-56 animate-[pulse_4s_ease-in-out_infinite]">
              {}
              <div className="absolute inset-0 bg-secondary rotate-0 rounded-2xl shadow-2xl transition-transform" />
              <div className="absolute inset-0 bg-secondary rotate-45 rounded-2xl shadow-2xl transition-transform" />
              <div className="absolute inset-0 bg-secondary rotate-[22.5deg] rounded-2xl shadow-2xl transition-transform" />
              <div className="absolute inset-0 bg-secondary rotate-[67.5deg] rounded-2xl shadow-2xl transition-transform" />
              
              {}
              <div className="relative z-20 text-secondary-foreground font-black text-center flex flex-col items-center justify-center p-4">
                <span className="text-7xl tracking-tighter leading-none drop-shadow-sm">25%</span>
                <span className="text-3xl tracking-widest uppercase leading-none mt-1 drop-shadow-sm">Off</span>
                <span className="text-base font-bold uppercase mt-2 bg-secondary-foreground text-secondary px-3 py-1 rounded-sm tracking-wider">
                  Repairs
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}